import axios from "axios";

const TOKEN_KEY = "auth_token";
const INACTIVITY_TIMEOUT = 120 * 60 * 1000; // 120 * 60 * 1000 is 2 hours in milliseconds
let inactivityTimer;
let listenersInitialized = false; // Flag per tracciare se i listener sono già stati inizializzati

// manage auto logout
const autoLogout = async () => {
  console.log("Auto logout triggered after inactivity");

  // Chiama l'API di logout per rimuovere l'utente da logged_users
  try {
    const token = getAuthToken();
    if (token) {
      await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/auth/logout`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      console.log("Logout API chiamata con successo");
    }
  } catch (error) {
    console.error("Errore durante il logout automatico:", error);
    // Procediamo comunque con il logout locale
  }

  setAuthToken(null);
  window.location.href = "/"; // redirect to login
};

// reset inactivity timer
const resetInactivityTimer = () => {
  // console.log("Resetting inactivity timer");
  if (inactivityTimer) {
    clearTimeout(inactivityTimer);
  }

  const token = getAuthToken();
  if (token) {
    // only if user is logged in
    // console.log("User is logged in, setting inactivity timer");
    inactivityTimer = setTimeout(autoLogout, INACTIVITY_TIMEOUT);
  } else {
    // console.log("No auth token found, not setting inactivity timer");
    return;
  }
};

// Initialize event listeners to detect user activities
const initializeActivityListeners = () => {
  // Evita di aggiungere i listener più volte
  if (listenersInitialized) {
    // console.log("Activity listeners already initialized, skipping");
    return;
  }

  // console.log("Initializing activity listeners");
  const events = ["mousedown", "keydown", "mousemove", "touchstart", "scroll"];
  events.forEach((event) => {
    document.addEventListener(event, resetInactivityTimer);
  });

  listenersInitialized = true;
  // Imposta il timer iniziale
  resetInactivityTimer();
};

// removes event listeners
const removeActivityListeners = () => {
  if (!listenersInitialized) {
    // console.log("No listeners to remove");
    return;
  }

  // console.log("Removing activity listeners");
  const events = ["mousedown", "keydown", "mousemove", "touchstart", "scroll"];
  events.forEach((event) => {
    document.removeEventListener(event, resetInactivityTimer);
  });

  listenersInitialized = false;
};

// Lista delle istanze axios da gestire
const axiosInstances = [];

// Funzione per registrare un'istanza axios
export const registerAxiosInstance = (instance) => {
  axiosInstances.push(instance);
};

export const setAuthToken = (token) => {
  try {
    if (token) {
      // console.log("Setting auth token");
      localStorage.setItem(TOKEN_KEY, token);
      // Aggiungi il token all'header Authorization per tutte le istanze axios
      const authHeader = `Bearer ${token}`;
      axios.defaults.headers.common["Authorization"] = authHeader;
      axiosInstances.forEach((instance) => {
        instance.defaults.headers.common["Authorization"] = authHeader;
      });
      initializeActivityListeners(); // Initialize activity monitoring
    } else {
      // console.log("Removing auth token");
      localStorage.removeItem(TOKEN_KEY);
      // Rimuovi l'header Authorization da tutte le istanze axios
      delete axios.defaults.headers.common["Authorization"];
      axiosInstances.forEach((instance) => {
        delete instance.defaults.headers.common["Authorization"];
      });
      if (inactivityTimer) {
        // console.log("Clearing inactivity timer");
        clearTimeout(inactivityTimer); // clear timer
      }
      removeActivityListeners(); // removes listeners
    }
  } catch (error) {
    console.error("Errore in setAuthToken:", error);
  }
};

export const getAuthToken = () => localStorage.getItem(TOKEN_KEY);

// Non inizializziamo il token qui, lo facciamo in App.jsx
// Questo evita la doppia inizializzazione
